import React from "react";
import ModalContainer from "../ModalContainer";
import { CURRENCY } from "../../../contants";
import { QRCodeCanvas } from "qrcode.react";

const UpiQrModal = ({ 
  open, 
  onClose, 
  billNumber, 
  amount,
  upiId = "", // Default UPI ID - can be made configurable
  merchantName = "" // Default merchant name - can be made configurable
}) => {
  const generateUpiLink = () => {
    if (!billNumber || !amount) return "";
    const note = `Bill#${billNumber}`;
    return `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      merchantName
    )}&am=${amount}&cu=INR&tn=${encodeURIComponent(note)}`;
  };

  const upiUrl = generateUpiLink();

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      size="md"
      title="UPI Payment"
    >
      <div className="d-flex flex-column align-items-center p-4">
        {upiUrl ? (
          <>
            <div className="mb-3 text-center">
              <h5 className="mb-2">Scan QR Code to Pay</h5>
              <p className="text-muted mb-0">Bill #{billNumber}</p>
            </div>
            
            <div className="bg-white p-3 border rounded mb-3">
              <QRCodeCanvas value={upiUrl} size={150} title="UPI QR Code" />
            </div>
            
            <div className="text-center">
              <h4 className="mb-2 font-weight-bold">
                {CURRENCY}{parseFloat(amount).toFixed(2)}
              </h4>
              <p className="text-muted small mb-0">
                Scan with any UPI app to pay
              </p>
              <p className="text-muted small">
                (Google Pay, PhonePe, Paytm, etc.)
              </p>
            </div>
            
            <div className="mt-3 p-3 bg-light rounded w-100">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted small">UPI ID:</span>
                <span className="font-weight-bold small">{upiId}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="text-muted small">Merchant:</span>
                <span className="font-weight-bold small">{merchantName}</span>
              </div>
            </div>
            
            <button
              className="btn btn-primary mt-3 w-100"
              onClick={onClose}
            >
              Payment Done / Close
            </button>
          </>
        ) : (
          <div className="text-center text-muted py-5">
            <i className="mdi mdi-qrcode-scan" style={{ fontSize: "48px" }}></i>
            <p className="mt-2">Invalid payment details</p>
          </div>
        )}
      </div>
    </ModalContainer>
  );
};

export default UpiQrModal;

